import React from 'react';
import adiTrack from './adi_track'

export function getUrlParams2(w) {
    let ret = {};
    w.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        ret[key] = value;
    });
    return ret;
}

export function shortDollarFormat(amt, rounding) {
    // rounding is optional: if not defined default display of decimals is used.
    if (amt === undefined || !amt) {
        return null;
    }
    amt = Number(amt);
    if (amt < 1000) {
        return amt;
    }
    amt = amt / 1000
    if (1000 > amt && amt > 20) {
        return amt.toFixed(0) + 'K'
    } else if (amt < 20) {
        return amt.toFixed(1) + 'K'
    } else {
        amt = amt / 1000
        return amt.toFixed(1) + 'M'
    }
}

export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatCurrency(amount) {
    if (amount === undefined || !amount) {
        return null;
    } else {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
            }).format(amount);
    }
}

export function formatSqFeet(sqfeet) {
    if (sqfeet === undefined || !sqfeet) {
        return null
    } else {
        return (new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                        }).format(sqfeet) + ' sqft')
    }
}

export function ShowValueWithIcon({ do_not_display_rent, list_type, exact, min, max, field = "", transform = (a => a), icon = null }) {
    if (do_not_display_rent === "on") {
        return "Call for Pricing"
    }
    else if (list_type === undefined || !list_type || (!exact && !min && !max) ) {
        return null;
    } else {
        return <span className="data-value">
            {icon}
            {   list_type.toUpperCase() !== 'COMMUNITY'
                ? transform(exact) + ' ' + field
                : min !== max
                    ? transform(min) + '-' + transform(max) + field
                    : transform(min) + ' ' + field
            }
        </span>
    }
}

export function findResaleCommunityValue(list_type, exact, min, max, field, transform = (a => a)) {
    if (list_type === undefined || !list_type || (!exact && !min && !max) ) {
        return null;
    } else {
        return list_type.toUpperCase() !== 'COMMUNITY'
            ? transform(exact) + ' ' + field
            : min !== max
                ? transform(min) + ' - ' + transform(max) + ' ' + field
                : transform(min) + ' ' + field
    }
}

export function formatAddress(city, state, zipcode) {
    const nbsp = "\u00a0";
    const stateZip = state
                        ? zipcode
                            ? state + nbsp +zipcode
                            : state
                        : zipcode || '';

    return (
        [city || null, stateZip].filter(i => i).join(", ")
    )
}

export function featureHasNoValue(feature) {
    return (
        (typeof feature === 'object' && feature !== null)
            ? feature.length === 0
            : !feature
    )
}

export function daysListed(createDate) {
    if (createDate === undefined || !createDate) {
        return null;
    }
    const months = {
            JAN: '0',
            FEB: '1',
            MAR: '2',
            APR: '3',
            MAY: '4',
            JUN: '5',
            JUL: '6',
            AUG: '7',
            SEP: '8',
            OCT: '9',
            NOV: '10',
            DEC: '11'
    };
    const splitDate = createDate.split('-');
    const monthNumber = months[splitDate[1].toUpperCase()];
    const dateCreated = new Date();
    dateCreated.setYear('20' + splitDate[2]);
    dateCreated.setMonth(monthNumber, splitDate[0]);
    const today = new Date();
    const daysListed = Math.round((today.getTime() - dateCreated.getTime())/(24*60*60*1000))
    return daysListed
        ? daysListed + ' Days Ago'
        : 'Today';
}

const nginxDirectives = {
	nginxDirectiveRE: "classre",
	"secure.adpay.com": "adpay",
	"view.admission.net": "admission",
	"photo.ewebengine.com": "ewebengine",
	"www.realestateone.com": "realestateone",
	"view.ipixmedia.com": "ipix",
	"mlsphoto.howardhanna.com": "howardhanna",
	"i1.e-net.com": "howardhanna2",
	"images4.e-net.com": "howardhanna3",
	"images.IMAGES1.e-net.com": "howardhanna4",
	"i2.e-net.com": "howardhanna5",
	"i.e-net.com": "howardhanna6",
	"images.IMAGES2.e-net.com": "howardhanna7",
	"images2.e-net.com": "howardhanna8",
	"ii.e-net.com": "howardhanna9",
	"media.e-net.com": "howardhanna10",
	"www.redata.com": "redata",
	"www.idxvow.com": "idx",
	"media.clicknbuy.com": "clicknbuy",
	"stagingmedia.clicknbuy.com": "clicknbuystg",
	"staging.adpay.com": "adpaystg",
	"images.grar.com": "grar",
	"medialaxf.rapmls.com": "rapmls",
	"www.realtytrac.com": "realtytrac",
	"www1.realtytrac.com": "realtytrac2",
	"images3.weichert.com": "weichert",
	"images4.weichert.com": "weichert2",
	"imagesc.weichert.com": "weichert3",
	"Tempo5.sandicor.com": "sandicor",
	"www.priv.njmls.xmlsweb.com": "njmls",
	"extimages2.living.net": "living",
	"ctarmls.com": "ctarmls",
	"tp.usamls.net": "usamls",
	"photos.flexmls.com": "flexmls",
	"mls.sckmls.com": "sckmls",
	"csmedia.mris.com": "mris",
	"photos.mris.com": "mris2",
	"images.prd.mris.com": "mris3",
	"www.carolinaphotos.com": "carolinaphotos",
	"mls.jacksonrealtor.com": "jacksonrealtor",
	"www.mobmls.net": "mobmls",
	"attach.realcomponline.com": "realcomponline",
	"glarmls.com": "glarmls",
	"pictures.realtracs.net": "realtracs",
	"ntreispictures.marketlinx.com": "marketlinx",
	"photos.mlswis.com": "mlswis",
	"69.2.104.71": "wave2",
	"al.adpay.com": "adpay-al",
	"cleveland.adpay.com": "adpay-cleve",
	"lehighvalleylive.adpay.com": "adpay-lvlive",
	"masslive.adpay.com": "adpay-mass",
	"mlive.adpay.com": "adpay-mlive",
	"nj.adpay.com": "adpay-nj",
	"nola.adpay.com": "adpay-nola",
	"oregonlive.adpay.com": "adpay-olive",
	"pennlive.adpay.com": "adpay-penn",
	"silive.adpay.com": "adpay-silive",
	"syracuse.adpay.com": "adpay-syracuse",
	"cmiar.com": "cmiar",
	"media2.nrtwebservices.com": "nrt",
	"img3.nrtwebservices.com": "nrtimg3",
	"69.2.104.130": "njnews",
	"www.plaind.com": "plaind",
	"cdn.cbhomes.com": "cbhomes",
	"m.cbhomes.com": "mcbhomes",
	"photo.pennjerseyacs.com": "pennjersey",
	"m.exports.nrtwebservices.com": "nrtmexports",
	"images.mris.com": "mris4",
	"images.marketleader.com": "marketleader",
	"pixad.advancelocal.com": "pixad",
    "api-prod.corelogic.com": "corelogic",
};

export function imageResize(url, width) {
    if (url === undefined || !url) {
        return null;
    }
    const nginxServer = "https://classimage.advance.net";
    try {
        let imageRemoteUrl = new URL(url);
        let imageRemoteOrigin = imageRemoteUrl.hostname;
        let imageRemoteLocation = imageRemoteUrl.pathname;
        let nginxDirective = nginxDirectives[imageRemoteOrigin] || nginxDirectives.nginxDirectiveRE;
        let noResize = [
            'm.cbhomes.com',
            'm.exports.nrtwebservices.com',
            'adpay.com',
            'api-prod.corelogic.com',
            'imgs.azureedge.net',
            'dlvp94zy6vayf.cloudfront.net',
            'dvvjkgh94f2v6.cloudfront.net',
        ].some(site => imageRemoteOrigin.includes(site));

        return noResize ? url : `${nginxServer}/classifieds/${nginxDirective}/width${width}/img${imageRemoteLocation}`;
    } catch (e) {
        console.log(url);
        return null;
    }
}

export function formatDetailDate(inputDate) {
    if (inputDate === undefined || !inputDate) {
        return null;
    }
    const months = {
        JAN: '1',
        FEB: '2',
        MAR: '3',
        APR: '4',
        MAY: '5',
        JUN: '6',
        JUL: '7',
        AUG: '8',
        SEP: '9',
        OCT: '10',
        NOV: '11',
        DEC: '12'
    };
    const splitDate = inputDate.split('-');
    const monthNumber = months[splitDate[1].toUpperCase()];
    return monthNumber + '/' + splitDate[0] + '/' + splitDate[2];

}

export function parseJsonLikeBlob(blob) {
    return blob ? JSON.parse(blob.replace(/%%%/g,',')) : null
}

export function findImage(imageArray, imageItem) {
    if (imageArray === undefined || !imageArray) {
        return null;
    }
    const images = imageArray ? parseJsonLikeBlob(imageArray) : null
    return images[0] ? images[0].image_url : null
}

export function convertPropType(item) {
    const propType = item.community_name
        ? item.community_name
        : item.property_type
            ? item.property_type
            : null;

    const mappedPropType = {
        "Single Family": "Single Family Home",
        "Multi-Family": "Multi-Family Home"
    }[propType];

    return mappedPropType === undefined
        ? propType
        : mappedPropType;
}


export const trackClick = (action, label) => {
    const analyticsObj = {
        category: "realestatesearch",
        action: action,
        label,
    };
    const eventConfig = {
        affiliateList: [ "all" ],
    };
    //console.log(analyticsObj);
    adiTrack.event(analyticsObj, eventConfig);
};

export const decodeHtml = (html) => {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

export const trackListTracEvent = (item, trackingEnabled, eventType) => {
        const isCommunity = (item.list_type && item.list_type.toUpperCase() === 'COMMUNITY') ? true : false;
        const dataProperty = item.property.toUpperCase();
        if (!isCommunity &&
            trackingEnabled &&
            typeof(window._LT) !== 'undefined' &&
            window._LT !== null &&
            !dataProperty.includes('ADPAY') &&
            !!item.agent_id_attribute) {
            try {
                window._LT._trackEvent(window._eventType[eventType], item.ad_number, item.zipcode, item.agent_id_attribute);
            } catch(err) {console.log('listtrac error' + err)}
        }
}

const partnerID = {
    "cleveland": "I67",
    "oregonlive": "I76",
    "nj": "I62",
    "silive": "I63",
    "syracuse": "I79",
    "al": "I73",
    "mlive": "I75",
    "masslive": "I94",
    "pennlive": "I68",
    "lehighvalleylive": "I8689",
    "gulflive": "I8697",
}

export const trackBDX = (id, affiliateName, action) => {
    console.log("track BDX:",action,"id:", id, "affiliate:", affiliateName, "partnerid:",partnerID[affiliateName]);
    fetch(`https://api.newhomesource.com/api/v2/log/partnerevent/partnerId-${partnerID[affiliateName]}/eventCode-${action}/propertyId-BHI${id}`,
        {
            method: 'POST',
            mode: 'no-cors'
        })
        .catch(err => {
            console.error(err);
        });
}


